import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN, TENANT_CODE_HEADER } from "store/auth/login/actionTypes";
// import { notification } from "antd";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const ENTRY_ROUTE = "/login";
const TOKEN_PAYLOAD_KEY = "authorization";
const X_TENANT = "X-Tenant";
const PUBLIC_REQUEST_KEY = "public-request";
const ACCESS_CONTROL_ALLOW_ORIGIN = "access-control-allow-origin";

const endpointEmailTemplate = "services/mspcnm/templates";
const tokenEmailTemplate =
  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI4ZjY1NjY2NC0xMTBlLTNlYzEtYWZkZS05ZWNkMTVmNzc0ZWIiLCJhdXRoIjoiUk9MRV9FSU5WT0lDRV9MU0FUSU5WT0lDRV9BRE1JTiIsInVzZXJJbmZvIjp7InVzZXJDb2RlIjoiZWludm9pY2UubHNhdGludm9pY2UuOGY2NTY2NjQtMTEwZS0zZWMxLWFmZGUtOWVjZDE1Zjc3NGViIiwiZnVsbE5hbWUiOiJOZ3V54buFbiDEkOG7qWMgSGnhur91IiwiZmlyc3RMb2dpblRpbWUiOjE2MzY0NzI4ODIwMDAsImxhc3RMb2dpblRpbWUiOjE2NDMxMTYzNTYxMjQsInVzZXJOYW1lIjoiOGY2NTY2NjQtMTEwZS0zZWMxLWFmZGUtOWVjZDE1Zjc3NGViIiwidGVuYW50Q29kZSI6IkxTQVRJTlZPSUNFIiwiYXBwQ29kZSI6IkVJTlZPSUNFIn0sImNsaWVudEluZm8iOnsiY2xpZW50Q29kZSI6IjhmNjU2NjY0LTExMGUtM2VjMS1hZmRlLTllY2QxNWY3NzRlYiIsImVtYWlsIjoiYWRtaW5AaW52b2ljZS5sc2F0LnZuIiwiZnVsbE5hbWUiOiJOZ3V54buFbiDEkOG7qWMgSGnhur91IiwiY2xpZW50VHlwZSI6MCwiY29udGFjdEVtYWlsIjoiIiwicGhvbmVOdW1iZXIiOiIwOTA5ODQ2NjYwIiwiY3JtUmVmIjoiIn0sImV4cCI6MTk0NTY4MzE1Nn0.NLutlWnIr5nOiumnTC-86eNSb8QDFAOJ7QUaG_nl68sYG3cgwZb4HivsdTqrycHLVn8WO6C01X15ONFWe2yTEA";

// API Request interceptor
service.interceptors.request.use(
  config => {
    let jwtToken = "Bearer " + localStorage.getItem(AUTH_TOKEN);
    if (jwtToken) {
      if (config.url.includes(endpointEmailTemplate)) {
        jwtToken = "Bearer " + tokenEmailTemplate;
      }
      const tenantCode = localStorage.getItem(TENANT_CODE_HEADER);
      if (tenantCode) {
        config.headers[X_TENANT] = localStorage.getItem(TENANT_CODE_HEADER);
      }
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }
    // if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
    //   history.push(ENTRY_ROUTE);
    //   window.location.reload();
    // }

    return config;
  },
  error => {
    // Do something with request error here
    // notification.error({
    //   message: "Error",
    // });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    let notificationParam = {
      message: "",
    };
    // Request bị huỷ (cancel token) hoặc lỗi mạng/timeout thì không có error.response
    if (axios.isCancel(error) || !error.response) {
      return Promise.reject(error);
    }
    // Remove token and redirect
    if (
      error.response.status === 400 ||
      // error.response.status === 403 ||
      error.response.status === 401
    ) {
      notificationParam.message = "Authentication Fail";
      notificationParam.description = "Please login again";
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem("authUserdev");
      localStorage.removeItem("authUserprod");
      // localStorage.removeItem(USER_INFO);
      // localStorage.removeItem(TENANT_CODE_HEADER);
      // localStorage.removeItem(BU_TENANT_HEADER);
      // localStorage.removeItem(BU_STORE_HEADER);
      // history.push(ENTRY_ROUTE);
      // window.location.reload();
    }

    if (error.response.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response.status === 508) {
      notificationParam.message = "Time Out";
    }

    // notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
